/* In-app-browser nudge.
   Shows a dismissible "open in your browser" bar ONLY inside Meta (Facebook /
   Instagram) in-app webviews, where Apple/Google Pay and autofill are absent
   and mobile checkout stalls. Best-effort hands off to Chrome (Android intent /
   iOS chrome scheme); otherwise copies the link and shows the manual step.
   Wrapped so it can never break the page. */
(function () {
  try {
    if (window.Shopify && window.Shopify.designMode) return; // don't show in the theme editor

    var ua = navigator.userAgent || '';
    var isMeta = /(FBAN|FBAV|FB_IAB|FB4A|FBIOS|Instagram)/i.test(ua);
    if (!isMeta) return;

    var KEY = 'iabNudgeDismissed';

    // Meta webviews can block any one storage layer, so check/write them all
    // and keep a window flag as the last resort for the current page.
    function isDismissed() {
      try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
      try { if (sessionStorage.getItem(KEY)) return true; } catch (e) {}
      try { if (document.cookie.indexOf(KEY + '=1') !== -1) return true; } catch (e) {}
      return window[KEY] === true;
    }
    function rememberDismissed() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      try { document.cookie = KEY + '=1; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {}
      window[KEY] = true;
    }

    if (isDismissed()) return;

    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    ready(function () {
      var el = document.getElementById('iabNudge');
      if (!el) return;
      el.hidden = false;

      var openBtn = el.querySelector('[data-iab-open]');
      var dismissBtn = el.querySelector('[data-iab-dismiss]');
      var hint = el.querySelector('[data-iab-hint]');
      var copiedNote = el.querySelector('[data-iab-copied]');

      function dismiss() {
        el.hidden = true;
        rememberDismissed();
      }
      if (dismissBtn) dismissBtn.addEventListener('click', dismiss);

      // The external browser has its own cookie jar, so handing off the plain
      // URL lands on an empty cart. A /cart/<variant>:<qty> permalink rebuilds
      // the cart there; fall back to the current URL on any failure.
      function handoffUrl(cb) {
        var href = window.location.href;
        try {
          if (!window.fetch) { cb(href); return; }
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var items = cart && cart.items;
              if (!cart || !cart.item_count || !items || !items.length) { cb(href); return; }
              var parts = [];
              for (var i = 0; i < items.length; i++) {
                parts.push(items[i].variant_id + ':' + items[i].quantity);
              }
              cb('https://' + window.location.host + '/cart/' + parts.join(','));
            })
            .catch(function () { cb(href); });
        } catch (e) { cb(href); }
      }

      function showHint(copied) {
        if (copiedNote) copiedNote.hidden = !copied;
        if (hint) hint.hidden = false;
      }

      // Only claim "we copied the link" if writeText actually resolved —
      // Meta webviews reject it silently.
      function copyThenHint(url) {
        var pending = null;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            pending = navigator.clipboard.writeText(url);
          }
        } catch (e) {}
        if (pending && pending.then) {
          pending.then(function () { showHint(true); }, function () { showHint(false); });
        } else {
          showHint(false);
        }
      }

      if (openBtn) openBtn.addEventListener('click', function () {
        handoffUrl(function (url) {
          var noScheme = url.replace(/^https?:\/\//, '');
          var isAndroid = /Android/i.test(ua);
          var isIOS = /iPhone|iPad|iPod/i.test(ua);

          if (isAndroid) {
            var intentUrl = 'intent://' + noScheme +
              '#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=' +
              encodeURIComponent(url) + ';end';
            try { window.location.href = intentUrl; } catch (e) {}
          } else if (isIOS) {
            // Opens Chrome if installed; harmless no-op otherwise.
            try { window.location.href = 'googlechromes://' + noScheme; } catch (e) {}
          }

          // Webviews often swallow the scheme navigation silently, so never
          // assume it worked: always surface the copy + manual step shortly
          // after. If the handoff did work, this page is backgrounded anyway.
          setTimeout(function () { copyThenHint(url); }, 400);
        });
      });
    });
  } catch (e) { /* never break the page */ }
})();
